// File: packages/apps/workoutsmart/src/sync/workoutPlanSyncDriver.js
import { fetchResource } from '@platform/core/src/services/resourceApi';
import { transformAiPlan } from '../utils/workoutPlanUtils';
import { applyPatchWithPartialProtection, mergeUpdateWithPartialProtection } from './syncUtils';

const workoutPlanSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      const newResource = await fetchResource(content.resource_type, content.resource_id);
      if (!newResource) return currentMap;
      const transformedResource = {
        ...transformAiPlan(newResource),
        type: 'workout_plan',
        resource_type: 'workout_plan',
      };
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (error) {
      return currentMap;
    }
  },

  handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    if (!resourceToPatch) return currentMap;

    try {
      const patchedResource = applyPatchWithPartialProtection(resourceToPatch, content.patches);
      const transformedResource = {
        ...transformAiPlan(patchedResource),
        type: 'workout_plan',
        resource_type: 'workout_plan',
      };
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (e) {
      return currentMap;
    }
  },

  handleUpdated(currentMap, content) {
    const existingResource = currentMap[content.resource_id];
    
    const protectedValue = mergeUpdateWithPartialProtection(existingResource, content.value);
    const transformedValue = {
      ...transformAiPlan(protectedValue),
      type: 'workout_plan',
      resource_type: 'workout_plan',
    };
    return { ...currentMap, [content.resource_id]: transformedValue };
  },
};

export default workoutPlanSyncDriver;